module.exports = __webpack_public_path__ + "public/img/xcs-4.ac1792da.jpg";